import styled from 'styled-components';

const BtnUpDel = styled.span`
    width: 20px;
    height: 20px;
    color: white;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
  `;

export default BtnUpDel;
